import { render, staticRenderFns } from "./Rewards.vue?vue&type=template&id=3a99df5a"
import script from "./Rewards.vue?vue&type=script&lang=js"
export * from "./Rewards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports